<div *ngIf="prikaziStranicu" class="container-fluid">
  <div class="content-block">
    <h2>Procesni koraci</h2>

    <div>
      <label>Proizvod:</label>
      <dx-select-box
        [disabled]="pravaZaTrenutniPogled != 2"
        #selectBox
        [dataSource]="sviProizvodi"
        displayExpr="sifraNaziv"
        valueExpr="id"
        (onValueChanged)="odaberiProizvod($event)"
        placeholder="Odaberi proizvod"
        [searchEnabled]="true"
        [searchExpr]="['sifra', 'naziv']"
        width="500"
      >
      </dx-select-box>
    </div>

    <div class="customTable" *ngIf="odabraniProizvod">
      <dx-data-grid
        class="my-40"
        [dataSource]="procesi"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        keyExpr="id"
        (onRowUpdated)="spremiPromjene($event)"
        (onCellPrepared)="onCellPrepared($event)"
      >
        <dxo-editing
          mode="batch"
          [allowUpdating]="true"
          [allowDeleting]="false"
          [selectTextOnEditStart]="true"
          [startEditAction]="'click'"
        >
        </dxo-editing>

        <dxi-column cellTemplate="aktivan" [width]="60">
          <div *dxTemplate="let data of 'aktivan'">
            <dx-button
              icon="{{ data.data.aktivan ? 'isnotblank' : 'isblank' }}"
              (onClick)="oznaciProces(data)"
            ></dx-button>
          </div>
        </dxi-column>
        <dxi-column dataField="aktivan" caption="" [width]="0"></dxi-column>
        <dxi-column
          dataField="rb"
          caption="Redni broj"
          [width]="65"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="naziv"
          caption="Proces"
          [width]="300"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="vtoum"
          caption="Vrijeme trajanja operacije u minutama"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="vtcpum"
          caption="Vrijeme trajanja cijelog procesa u minutama"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="vrrum"
          caption="Vrijeme rada radnika u minutama"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="brno"
          caption="Broj radnika na operaciji"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="vsrno"
          caption="Vrijeme svih radnika na operaciji"
          [width]="150"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="crrum"
          caption="Cijena rada radnika u minuti"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="ucrpo"
          caption="Ukupna cijena rada po operacijama"
          [width]="150"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
